function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';

var uscc = function uscc(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "10.8554",
    y: "1.01985",
    width: "18.9753",
    height: "18.9753",
    stroke: "black",
    strokeWidth: "2.03969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "10.5218",
    y: "25.8898",
    width: "5.12665",
    height: "5.12665",
    transform: "rotate(45 10.5218 25.8898)",
    stroke: "black",
    strokeWidth: "2.00143"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1.01985",
    y: "20.0048",
    width: "18.9753",
    height: "18.9753",
    stroke: "black",
    strokeWidth: "2.03969"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "20.0048",
    y: "20.0048",
    width: "18.9753",
    height: "18.9753",
    stroke: "black",
    strokeWidth: "2.03969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4878 32.6447L29.5211 27.391L32.5543 32.6447H26.4878Z",
    stroke: "black",
    strokeWidth: "2.00143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0541 10.5L17.9156 7.91557L20.5 7.05409L23.0844 7.91557L23.9459 10.5L23.0844 13.0844L20.5 13.9459L17.9156 13.0844L17.0541 10.5Z",
    stroke: "black",
    strokeWidth: "2"
  }));
};

export default uscc;